module.exports = __webpack_public_path__ + "sprite/buttons.png";


//////////////////
// WEBPACK FOOTER
// ./sprite/buttons.png
// module id = 53
// module chunks = d-game